import { setGiftCardInfos } from "@actions/gift-card-actions";
import { useDispatch, useSelector } from "react-redux";

export function useGiftCardInfos() {
  return useSelector((state) => state.giftCardInfos);
}

export function useSetGiftCardInfos() {
  const dispatch = useDispatch();

  return (giftCardInfos) => dispatch(setGiftCardInfos(giftCardInfos));
}
